<template>
  <div class="o-container o-container--thin onboarding-page" :class="{'eoi-form-top-gap': $route.name === 'eoi'}">
    <eoi-form :submit="onSubmit"/>
  </div>
</template>

<script>
  import Checkbox from '../formFields/Checkbox.vue';
  import EoiForm from "../forms/EoiForm";
  import api from "../../api";

	export default {
    components: {
      EoiForm,
      Checkbox
    },
    data() {
      return {
        isLoading: false,
        checkbox: {
          isChecked: true,
          txt: 'Entered'
        },
        alreadySubscribed: false
      }
    },
    methods: {
      async onSubmit(eoiOptInData) {
        console.info("START_calling_user.EOI_OPTIN");
        console.time("TIME_calling_user.EOI_OPTIN");

        this.isLoading = true;

        const payload = {
          for_child                                 : eoiOptInData.forChild,
          for_you                                   : eoiOptInData.forYou,
          family_member                             : eoiOptInData.familyMember,
          you_and_child                             : eoiOptInData.youAndChild,
          first_name                                : eoiOptInData.firstName,
          last_name                                 : eoiOptInData.lastName,
          email                                     : eoiOptInData.email,
          state                                     : eoiOptInData.state,
          postcode                                  : eoiOptInData.postcode,
          were_you_registered_with_a_club_in_2022   : eoiOptInData.wereYouRegisteredWithAClubIn2022,
          club_name                                 : eoiOptInData.clubName,
          football_match_type                       : eoiOptInData.footballType,
          people_count                              : eoiOptInData.peopleCount,
          child_count                               : eoiOptInData.childCount,
          was_child_registered_with_a_club_in_2022  : eoiOptInData.wasChildRegisteredWithAClubIn2022,
          child_club_name                           : eoiOptInData.childClubName,
          comments                                  : eoiOptInData.comments,
        }

        api.crm.createEoi(payload)
            .then(async (eoi) => {
              api.crm.sendPinpointMessage({email: payload.email, app_id: PinpointAppId}).then(async (response) => {
                console.log(response)
              });
              // if (eoi.status === 'success') {
                this.$router.push({
                  name: 'thank-you'
                });
              // }
              this.isLoading = false;
            })
            .catch((err) => {
              window.scrollTo(0, 0);
              this.isLoading = false;
              this.errors = {global: "Something went wrong trying to update your preferences."};
              console.info("err", err);
            });
      }
    }
  }
</script>

<style scoped>

.offer-shirt img {
  width: -webkit-fill-available;
  height: auto;
}

</style>